module.exports = __webpack_public_path__ + "img/er.235e0cd2.png";